import FiltersController from 'JS/classes/FiltersController';
import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';

class MobileFilter {

    type = 'mobile';
    opened = false;

    constructor(filterBtn, filterWrap) {
        if (!filterBtn || !filterWrap) {
            return;
        }
        
        this.filterBtn = filterBtn;
        this.filter = filterWrap;
        this.filters = this.filter.querySelector('.product-filters-mobile__filters');
        this.filterItems = this.filter.querySelectorAll('.product-filters-mobile__filter');
        this.init();

        const controller = new FiltersController(this.filter, this);

        this.fillLabels(controller.filtersForm.collectValues(), controller.filtersForm);
        
        controller.filtersForm.on('change', (data) => {
            this.fillLabels(data, controller.filtersForm);
        });

        let sortType = controller.sortType;
        controller.filtersForm.on('change', (data) => {
            if (data.sort_type !== sortType) {
                this.closeFilters();
                sortType = data.sort_type;
            }
        });

        this.controller = controller;
    }

    init() {
        this.filterBtn.addEventListener('click', () => {
            this.opened = !this.opened;
            this.toggleTabs(this.filters, this.filterBtn, this.opened);
        });

        this.filterItems.forEach(element => {
            const filterOutput = element.querySelector('.product-filters-mobile__filter-output');
            element.addEventListener('click', () => {
                const openWrap = element.querySelector('.product-filters-mobile__filter-overflow');
                this.toggleTabs(openWrap, element);

                if (element.classList.contains('active')) {
                    filterOutput.classList.add('close');
                } else {
                    filterOutput.classList.remove('close');
                }
            });
        });

        this.addListeners();
    }

    addListeners() {
        this.applySticky();

        window.addEventListener('scroll', () => {
            requestAnimationFrame(() => {
                this.applySticky();
            });
        });

        window.addEventListener('resize', () => {
            requestAnimationFrame(() => {
                this.changeOuterHeight();
            });
        });
    }

    changeOuterHeight() {
        if (!this.outer) {
            return;
        }
        if (window.innerWidth < 768) {
            return;
        }
        this.outer.style.height = `${this.filter.getBoundingClientRect().height}px`;
    }

    applySticky() {
        if (window.innerWidth >= 768) {
            return;
        }

        if (!this.outer) {
            const wrap = (el, wrapper) => {
                el.parentNode.insertBefore(wrapper, el);
                wrapper.appendChild(el);
            };

            this.outer = document.createElement('div');
            
            wrap(this.filter, this.outer);

            Object.assign(this.outer.style, {
                'position': 'relative',
                'height': `${this.filter.getBoundingClientRect().height}px`,
            });

            Object.assign(this.filter.style, {
                'position': 'absolute',
                'top': '0',
                'left': '0',
            });
        }

        const headerContent = document.querySelector('.header__content');
        const headerShopOptions = document.querySelector('.header__shop-options');

        let top = [headerContent, headerShopOptions].reduce((prev, current) => {
            if (current) {
                return prev + current.clientHeight;
            }
            return prev;
        }, -1);

        const elTop = this.outer.getBoundingClientRect().top;

        if (elTop < top) {
            Object.assign(this.filter.style, {
                'position': 'fixed',
                'top': `${top}px`,
                'left': 'var(--main-padding)',
                'width': '100%',
            });
        } else {
            Object.assign(this.filter.style, {
                'position': 'absolute',
                'top': '0',
                'left': '0',
            });
            this.filter.style.removeProperty('width');
        }
    }

    toggleTabs(toggledEl, activatedEl, to = undefined) {
        activatedEl.classList.toggle('active', to);
        toggledEl.classList.toggle('active', to);

        if (typeof to !== 'undefined') {
            this.opened = to;
        }

        // if (this.opened) {
        //     lockScroll();
        // } else {
        //     unlockScroll();
        // }
    }

    closeFilters() {
        this.toggleTabs(this.filters, this.filterBtn, false);
    }

    fillLabels(data, form) {
        const labels = Array.from(this.filter.querySelectorAll('[data-output]'));

        const title = this.filter.querySelector('.product-filters-mobile__controller-title');

        

        labels.forEach(labelEl => {
            labelEl.innerHTML = '';

            const label = labelEl.dataset.output;
            let values = data[label] ?? false;

            if (!values.length) {
                return;
            }

            if (!Array.isArray(values)) {
                values = [values];
            }

            const outputValues = [];

            values.forEach(v => {
                const input = form.formElement.querySelector(`[value="${v}"]`);

                if (!input) {
                    return;
                }
                const text = input.closest('label').querySelector('span').innerHTML;
                outputValues.push(text);
            });
            labelEl.innerHTML = outputValues.join(', ');

            if (label === 'product_cat') {
                title.innerHTML = outputValues.join(', ');
            }
        });
    }
};

const filterBtn = document.querySelector('.product-filters-mobile__controller-btn');
const filterWrap = document.querySelector('.product-filters-mobile');

window.mobileFilters = new MobileFilter(filterBtn, filterWrap);
